import React from 'react';
import classNames from 'classnames';
export var PlacementType;
(function (PlacementType) {
    PlacementType["INNER"] = "inner";
    PlacementType["OUTER"] = "outer";
})(PlacementType || (PlacementType = {}));
const CarouselControl = ({ direction, onClickHandler, className, children, isActive, placement }) => {
    const anchorClasses = classNames(className, `carousel-control-${direction}`, `carousel-control-${isActive ? 'active' : 'disabled'}`, placement);
    return (<button className={anchorClasses} onClick={(event) => {
            event.preventDefault();
            onClickHandler();
        }}>
            {children}
        </button>);
};
export default CarouselControl;
